import { SIGNUP_TEXT } from "../../domain/constants/constants";
import { styles as s } from "../../styles/signupstyles";

type Props = {
  value: "email" | "phone";
  onChange: (value: "email" | "phone") => void;
};

export default function MethodToggle({
  value,
  onChange,
}: Props) {
  return (
    <div className={s.toggleContainer}>
      <button
        type="button"
        onClick={() => onChange("email")}
        className={`${s.toggleButton} ${
          value === "email"
            ? s.toggleActive
            : s.toggleInactive
        }`}
      >
        {SIGNUP_TEXT.emailTab}
      </button>

      <button
        type="button"
        onClick={() => onChange("phone")}
        className={`${s.toggleButton} ${
          value === "phone"
            ? s.toggleActive
            : s.toggleInactive
        }`}
      >
        {SIGNUP_TEXT.phoneTab}
      </button>
    </div>
  );
}